import {IconButton} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box, Stack} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronDownLine, ChevronRightLine, WorkstreamsLine} from '@dropbox/dig-icons/assets';
import cx from 'classnames';
import {t} from 'i18next';
import {ReactNode} from 'react';
import styles from 'views/workstreams/detail/WorkstreamTable.module.css';

export const WorkstreamRedesignSubworkstreamSummaryRow = ({
  subworkstreamCount,
  isExpanded = false,
  isDependency = false,
  statusScores,
  onToggle,
}: {
  subworkstreamCount: number;
  isExpanded?: boolean;
  isDependency?: boolean;
  statusScores?: ReactNode;
  onToggle?: () => void;
}) => {
  if (isDependency) {
    return (
      <Stack gap="4">
        <Box
          display="flex"
          alignItems="center"
          className={cx(styles.metaRow, styles.workstreamMetaRowRedesign)}
        >
          <Box className={styles.metaRowIcon}>
            <UIIcon src={WorkstreamsLine} size="small" className={atoms({color: 'Text Subtle'})} />
          </Box>
          <button type="button" className={styles.metaRowAction} disabled>
            <Text size="small">{t('sub_workstream_count', {count: subworkstreamCount})}</Text>
          </button>
        </Box>
        {statusScores ? (
          <Box display="flex" alignItems="center" style={{marginLeft: '18px'}}>
            {statusScores}
          </Box>
        ) : null}
      </Stack>
    );
  }

  return (
    <Stack gap="4">
      <Box
        display="flex"
        alignItems="center"
        className={cx(
          styles.subworkstreamSummaryRow,
          styles.workstreamMetaRowRedesign,
          isExpanded && styles.subworkstreamSummaryRowExpanded
        )}
      >
        <IconButton
          variant="borderless"
          size="small"
          aria-label={t('sub_workstream_count', {count: subworkstreamCount}).toString()}
          onClick={onToggle}
        >
          <UIIcon
            src={isExpanded ? ChevronDownLine : ChevronRightLine}
            size="small"
            className={atoms({color: 'Text Subtle'})}
          />
        </IconButton>
        {statusScores ? (
          <Box className={styles.subworkstreamStatusScores}>{statusScores}</Box>
        ) : null}
      </Box>
    </Stack>
  );
};
